<template>
  <div 
    class="d-flex h-100"
    :class="isMobile ? 'flex-column' : ''"
  >
    <div 
        class="w-50 pb-2"
        :class="isMobile ? 'w-100' : 'w-50 pr-15'"
    >
      <VSkeletonLoader
        class="w-100"
        type="card-heading, list-item-three-line, divider, card-heading, divider, list-item-three-line"
      />
    </div>
    <div
        class="w-50 pr-15 pt-25"
        :class="isMobile ? 'w-100' : 'w-50 right-column'"
    >
      <VSkeletonLoader type="list-item-three-line" class="pt-25" />
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'SConfirmationSkeletonLoader',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { useVuetify } from '../../composables';

const vuetify = useVuetify();

const isMobile = computed(() => vuetify.breakpoint.xs);
</script>
<style lang="scss" scoped>
.right-column {
    padding-top: 62px;
}
</style>
